import React from 'react';
import { Page as RegisterPage } from './pages/registerPage';
import { RegisterPageTranslationsFunnelProvider } from './TranslationsFunnelProvider';
const RegisterFunnel = () => /*#__PURE__*/React.createElement(RegisterPageTranslationsFunnelProvider, null, /*#__PURE__*/React.createElement(RegisterPage, null));
export default RegisterFunnel;